<div id="footer" class="sl:py-[32px] sl:px-[16px] md:py-[80px] md:px-[64px] xl:pt-[80px] xl:pb-[120px] xl:px-[64px]">
    <div class="grid grid-cols-1 xl:grid-cols-2 gap-x-24">
        <div class="w-full">
            <div class="flex items-center">
                <img class="sl:h-[20px] md:h-[38px] w-auto flex-shrink" src="assets/images/globalpayment.svg" alt="globalpayment" />
                <img class="sl:h-[20px] md:h-[38px] w-auto flex-shrink md:px-[20px] sl:px-[16px]" src="assets/images/divider.svg" alt="separator-line" id="divider" />
                <img class="sl:h-[20px] md:h-[34px] w-auto flex-shrink" src="assets/images/logo-white.svg" alt="logo" />
             </div>  
            <div class="mt-6 title sl:text-14 md:text-20">
                <span>Global Payments China Development Services</span>
            </div>
        </div>

        <div class="xl:ml-auto xl:mt-0 md:mt-[56px] sl:mt-[24px]">
            <div class="grid grid-cols-2">
                <div class="column right-block mr-[120px]">
                    <div class="title sl:text-14 md:text-20">Pricing</div>
                    <div class="link sl:text-12 md:text-16 sl:mt-[12px] md:mt-[24px] font-medium"><a [routerLink]="['/main/cost-plan']">Cost Plan</a></div>
                </div>
                <div class="column right-block">
                    <div class="title sl:text-14 md:text-20">About</div>
                    <div class="link sl:text-12 md:text-16 sl:mt-[12px] md:mt-[24px] font-medium"><a [routerLink]="['/main/about-us']">About Us</a></div>
                </div>
            </div>
        </div>
    </div>
    <div class="title sl:text-14 md:text-20 sl:mt-[24px] sl:mb-[12px] md:mt-[56px] md:mb-[24px]" id="address">Address</div>
    <div class="sl:text-12 md:text-16">
        6F, Building C, Xi'an Hi-tech Zone Huanpu Industrial Park, Side Rd of W. 3rd Ring Rd, Yanta District, Xi'an, Shaanxi, China
    </div>
    <div class="sl:text-12 md:text-16 md:mb-[80px] sl:mb-[20px] sl:mt-[8px]">49F, Tower 1, Chengdu IFS, No.1 Section 3 Hong Xing Road, Jin Jiang Zone, Chengdu, China</div>
    <div class="line md:my-[80px] sl:my-[20px]"></div>
    <div class="grid grid-cols-1 md:grid-cols-[1fr_auto] sl:text-12 md:text-16 gap-3">
        <div class="break-words">Copyright © Global Payments 2025</div>
        <!-- <div class="flex flex-col md:flex-row md:justify-end md:items-start xl:items-center whitespace-nowrap">
            <div class="mr-6 sl:mb-[8px] md:mb-[0]"><a href="" target="_blank" class="link">Terms of Use</a></div>
            <div class="mr-6 sl:mb-[8px] md:mb-[0]"><a href="" target="_blank" class="link">Product and Service Terms</a></div>
            <div class="sl:mb-[8px] md:mb-[0]"><a href="" target="_blank" class="link">Privacy Rights</a></div>
        </div> -->
    </div>
</div>
